<template>
    <q-btn
        unelevated
        class="nomal"
        :class="options?.class"
        :label="options?.label"
        :style="options?.style"
        :color="options.color"
        :flat="options?.flat ? true : false"
        :outline="options?.outline ? true : false"
        :text-color="options?.textColor"
        :icon="options?.icon"
        :onclick="onClickFn"
    >
    </q-btn>
</template>

<script setup>
import { onMounted, onUnmounted, ref } from 'vue';
import { soundEffect } from '@/helpers/soundEffect';
import { GlobalStore } from '@/store';

const globalStore = GlobalStore();
const emit = defineEmits(['onClickFn']);
const props = defineProps({
    options: {
        default: {},
    },
});
const isDisabled = ref(false);

const onClickFn = () => {
    if (isDisabled.value) return;
    isDisabled.value = true;

    if (globalStore?.sound && props.options?.sound) {
        soundEffect(props.options?.sound);
    }
    emit('onClickFn');

    setTimeout(() => {
        isDisabled.value = false;
    }, 500);
};

onMounted(() => {
    // console.log('--onMounted cqBtn--');
});

onUnmounted(() => {
    // root.dispose();
});
</script>

<style scoped lang="scss">
.second {
    background-color: none;
    color: black;
    border: 1px solid black;
    border-color: black;
    border-radius: 12px;
}
</style>
